export {
  default,
  MARKDOWN_EDITOR_CONTENT_CLASS
} from '@cavela/ui/components/ui/MarkdownEditor';
export type { MarkdownEditorProps } from '@cavela/ui/components/ui/MarkdownEditor';

/**
 * Wrapper classes for a MarkdownEditor at the top of a bordered, rounded
 * composer box (message text above an attachments row). The box doesn't clip
 * its children, so the toolbar rounds its own top corners to match the box.
 */
export const COMPOSER_EDITOR_CLASS = '[&_.mdxeditor-toolbar]:!rounded-t-xl';

/** Content area classes for a MarkdownEditor inside a composer box. */
export const COMPOSER_EDITOR_CONTENT_CLASS = 'min-h-20 px-3 py-2';
